import { useEffect, useState } from "react";
import { Button, ListGroup, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { api_without_cancellation } from "../../../../api/api";
import { fetchProviderClient, fetchUsers } from "../../../../Redux/new-chat-store/chatSlice";
import "./create-group-modal.css";
import UserChatBubble from "../../../Forms/FirmUserBtn";

const CreateGroupModal = ({ isOpen, onClose, onCreateGroup }) => {
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const [groupName, setGroupName] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");

  const chatState = useSelector((state) => state.chat2);
  const dispatch = useDispatch();

  const fetchUsers2 = async () => {
    try {
      const response = await api_without_cancellation.get("/api/chat/users/roster/");
      const data = await response.data;
      setUsers(data);
      // return data;
    } catch (error) {
      console.error(error);
      //  return rejectWithValue(error.message);
    }
  };

  useEffect(() => {
    fetchUsers2();
  }, []);

  const toggleUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleSubmit = () => {
    if (groupName === "") {
      toast.error("Please enter a group name.");
      return;
    }
    if (selectedUsers.length === 0) {
      toast.error("Please select at least one user.");
      return;
    }
    onCreateGroup({
      name: groupName.trim() === "" ? "New Group" : groupName.trim(),
      selectedUserIds: selectedUsers,
      group_content: message,
    });
    if (chatState.selectedFirm) {
      if (chatState.selectedFirm.type === "attorney") {
        dispatch(
          fetchUsers({
            firmId: chatState.selectedFirm.id,
            search: chatState.userSearch,
          })
        );
      } else if (chatState.selectedFirm.type === "provider") {
        dispatch(
          fetchProviderClient({
            firmId: chatState.selectedFirm.id,
            search: chatState.userSearch,
          })
        );
      }
    }
    setGroupName("");
    setSelectedUsers([]);
    onClose();
  };

  const filteredUsers = users.filter((u) =>
    u.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const isDisabled = selectedUsers.length < 2 || groupName === "";

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        size=""
        centered
        dialogClassName="custom-group-modal-width"
      >
        <div style={{ borderRadius: "0px", overflow: "hidden" }}>
          {/* Custom Header */}
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Create New Group
            </Modal.Title>
          </Modal.Header>

          {/* Custom Body */}
          <div style={{ padding: "5px", maxHeight: "60vh", overflowY: "auto" }}>
            {/* Group Name Input */}
            <div style={{ marginBottom: "5px" }}>
              <input
                type="text"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                placeholder="Enter group name"
                className="form-control height-25"
                maxLength={15}
              />
            </div>

            {/* Select Members */}
            <div>
              {/* Search box */}
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search users..."
                className="form-control height-25"
              />

              {/* User list */}
              <ListGroup
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "5px",
                  scrollbarWidth: "none",
                }}
              >
                {filteredUsers.length === 0 ? (
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#94a3b8",
                      textAlign: "center",
                      margin: "0",
                      gridColumn: "1 / -1",
                    }}
                  >
                    No users found
                  </p>
                ) : (
                  filteredUsers.map((user) => {
                    const userKey = user.id;
                    // const selected = selectedUsers.has(userKey);

                    return (
                      <ListGroup.Item
                        key={userKey}
                        className="d-flex align-items-center"
                        style={{
                          cursor: "pointer",
                          border: "none",
                          padding: "5px",
                          // borderRadius: "6px",
                        }}
                        onClick={() => toggleUser(userKey)}
                      >
                        <input
                          type="checkbox"
                          checked={selectedUsers.includes(userKey)}
                          // onChange={() => toggleUser(userKey)}
                          className="" // Your custom classes only
                          style={{
                            width: "13px",
                            height: "13px",
                            minHeight: "13px",
                            cursor: "pointer",
                            marginRight: "10px",
                          }}
                        />

                        <div className="d-flex align-items-center grow">
                          {/* {user?.avatar_url ? (
                            <img
                              src={user?.avatar_url}
                              alt={user?.name}
                              className="rounded-circle m-r-5"
                              width="29"
                              height="29"
                              style={{
                                objectFit: "cover",
                                border: "2px solid var(--primary-25)",
                              }}
                            />
                          ) : (
                            <img
                              src={avatarImg}
                              alt={user?.name}
                              className="rounded-circle m-r-5"
                              width="29"
                              height="29"
                              style={{
                                objectFit: "cover",
                                border: "2px solid var(--primary-25)",
                              }}
                            />
                          )}

                          <div className="grow">
                            <span className="fw-medium">{user?.name}</span>
                          </div> */}
                          <UserChatBubble
                            isActive={userOnlineStatus?.[user?.id] ?? false}
                            first_name={user?.name}
                            last_name={""}
                            profilePic={user?.avatar_url || ""}
                            is_active={user?.is_active}
                          />
                        </div>
                      </ListGroup.Item>
                    );
                  })
                )}
              </ListGroup>
            </div>
            {/* message box */}
            <div className="p-t-5 p-b-5 p-l-5 p-r-5">
              <textarea
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{
                  width: "100%",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  resize: "none",
                  height: "75px",
                  fontSize: "14px",
                  fontWeight: "400",
                  border: "1px solid var(--primary-25)",
                  borderRadius: "0px",
                  color: "black",
                }}
                placeholder="Enter Chat Message"
                className="form-control"
              />
            </div>
          </div>

          {/* Custom Footer */}
          <Modal.Footer
            className="p-0 mt-0 padding-outside-btn-new-provider"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant={isDisabled ? "secondary" : "success"}
              disabled={isDisabled}
              style={{
                cursor: isDisabled ? "not-allowed" : "pointer",
                width: "116px",
                minWidth: "116px",
              }}
              onClick={handleSubmit}
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            >
              Create Group
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <style jsx global>{`
        .custom-modal-width .modal-dialog {
          max-width: 400px !important;
        }

        .custom-modal-width .modal-content {
          border-radius: 16px !important;
          border: none !important;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
        }

        .custom-modal-width .modal-header,
        .custom-modal-width .modal-body,
        .custom-modal-width .modal-footer {
          padding: 0 !important;
          border: none !important;
          background: transparent !important;
        }
      `}</style>
    </>
  );
};

export default CreateGroupModal;
